import SteveDescriptionModel from '@shell/plugins/steve/steve-description-class';

export default class PodSecurityAdmissionTemplate extends SteveDescriptionModel { }
